import React from 'react';
import { SVGIcon } from '../SVGIcon/SVGIcon';
import { IconName } from '../SVGIcon/SVGIcon.types';
import clsx from 'clsx';

export interface SectionTitleProps {
  title: string;
  description?: string;
  bgWhite?: boolean;
  icon?: IconName;
}

function SectionTitle({
  title,
  description,
  icon,
  bgWhite = false,
}: SectionTitleProps) {
  return (
    <div
      className={clsx(
        'flex w-full max-w-full flex-shrink-0 flex-grow-0 items-start justify-start gap-3 border-b border-t border-[#EAECF6] px-4 py-6 lg:gap-6 lg:px-[48px] lg:py-6',
        bgWhite ? 'border-gray-200' : 'border-transparent',
      )}
      style={{
        background: bgWhite
          ? 'linear-gradient(to right, #e5eef8 0%, #fafcff 2.42%)'
          : 'transparent',
      }}
    >
      <div
        className={clsx(
          'relative flex h-[48px] w-[48px] flex-shrink-0 flex-grow-0 items-center justify-center gap-2.5 rounded-xl bg-blue lg:h-[56px] lg:w-[56px]',
        )}
      >
        {icon && <SVGIcon name={icon} fill="#E1EAF7" />}
      </div>
      <div className="relative flex w-[80%] flex-shrink-0 flex-grow-0 flex-col items-start justify-start lg:gap-3">
        <h3
          className={clsx(
            'flex-grow-0 flex-shrink-0 self-stretch w-full text-2xl font-bold text-left lg:max-w-1/2 lg:text-3xl xl:text-5xl',
            bgWhite ? 'text-black' : 'text-white',
          )}
        >
          {title}
        </h3>
        {description && (
          <p
            className={`flex-shrink-0 flex-grow-0 pt-3 text-left text-sm ${bgWhite ? `text-grayText` : `text-[#afc4f0]`
              }`}
          >
            {description}
          </p>
        )}
      </div>
    </div>
  );
}

export default SectionTitle;
